import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'playlistFilter'
})

export class PlaylistFilterPipe implements PipeTransform {
    transform(items: any[], filter: string, fieldName: string = 'PlaylistTitle'): any {

        if (!items || !filter) {
            return items;
        }
        return items.filter(item => item[fieldName].toLowerCase().includes(filter.toLowerCase()));
    }
}
